import React from 'react';
import { useStockSummary } from '../hooks/useInventory';
import { FiltersBar } from '../components/FiltersBar';
import { SvgBarChart } from '../components/SvgBarChart';
import { DataTable } from '../components/DataTable';

const StockSummary: React.FC = () => {
  const [filters, setFilters] = React.useState<Record<string, string>>({});
  const { data } = useStockSummary(filters);
  const chartData = (data ?? []).map((d) => ({ label: d.label, value: d.total }));
  return (
    <div className="p-4 space-y-4">
      <h1 className="text-xl font-semibold">Resumen de stock</h1>
      <FiltersBar onChange={setFilters} defaults={filters} />
      <SvgBarChart data={chartData} title="Total por agrupación" />
      <DataTable title="Detalle" data={data ?? []} columns={[{ key: 'label', label: 'Grupo' }, { key: 'total', label: 'Total' }]} />
    </div>
  );
};

export default StockSummary;
